const BYTES_IN_MB = 1024 * 1024;
export const bytesToMb = (bytes: number) => bytes / BYTES_IN_MB;
